import { RESET } from "../utils/constants";
import store from "./store";

export const resetAllState = () => store.dispatch({ type: RESET }); // Reset all states
